import Splide from "@splidejs/splide";


document.addEventListener("DOMContentLoaded", function () {
  const testimonialsSlider = document.getElementById("testimonials-slider");


  if (testimonialsSlider) {
    const testimonialSlider = new Splide(testimonialsSlider, {
      type: "carousel",
      perPage: 1,
      perMove: 1,
      focus: "center",
      rewind: true,
      arrows: false,
      pagination: true,
      mediaQuery: "min",
      breakpoints: {
        768: {
          pagination: false,
          arrows: true
        },
      },
    }).mount();
  }

});